import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { ElectricalInspection } from 'types/Documents';

export const useElectricalInspection = (id: string | null) =>
  useDocumentDetails<Document<ElectricalInspection> | null>(id);
